import BaseView from 'components-framework/view/base.view';
import {EVENTS, STATES} from './constants';

export const DocumentUploadView = BaseView.extend({
    ignoreModelUpdate: false,
    events: EVENTS,
    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
        this.render = this.render.bind(this);
        this.listenTo(this.model, 'modelUpdated', this.render);
    },
    onBackClick() {
        Odigeo.trigger(`${this.id}:onClickBackButton`);
    },
    onDoneClick() {
        Odigeo.trigger(`${this.id}:onClickDoneButton`);
    },
    onUploadButtonCLicked(event) {
        const $currentTarget = this.$(event.currentTarget);
        const $inputFile = $currentTarget.children('input');
        $inputFile.click();
    },
    onFileUpload(event) {
        const $currentTarget = $(event.currentTarget);
        const category = $currentTarget.data('category');
        const files = $currentTarget.prop('files');

        if (files.length > 0) {
            const file = files[0];
            this.model.attachFile(file, category);
            $currentTarget.val(null);
        }
    },
    render() {
        const {
            templates: {
                grid,
                buttonTemplate,
            },
            $el,
            keys,
        } = this;

        const bookingID = this.model.get('bookingID');
        const buttons = this.model.get('uploadButtons').map(({category, state, quantity}) =>
            buttonTemplate({category, state, quantity, keys, STATES})
        ).join('');

        return $el.html(grid({
            keys,
            bookingID,
            children: {
                buttons,
            },
        }));
    },
});
